import { Message } from "semantic-ui-react";
import { SurveyTypeConfig } from "../config/surveyTypes";

export const EndScreen = ({
  config,
}: {
  config: SurveyTypeConfig["endScreen"];
}) => {
  return (
    <Message positive>
      <h2>{config.title}</h2>
      {config.messages.map((message, index) => (
        <p key={index}>{message}</p>
      ))}
      <p>{config.closingMessage}</p>
    </Message>
  );
};
